import { render, staticRenderFns } from "./addAdvertisePosition.vue?vue&type=template&id=11466bb2&scoped=true"
import script from "./addAdvertisePosition.vue?vue&type=script&lang=js"
export * from "./addAdvertisePosition.vue?vue&type=script&lang=js"
import style0 from "./addAdvertisePosition.vue?vue&type=style&index=0&id=11466bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11466bb2",
  null
  
)

export default component.exports